import { render } from "./fileTypeValidation.vue?vue&type=template&id=3feee434&scoped=true"
import script from "./fileTypeValidation.vue?vue&type=script&lang=js"
export * from "./fileTypeValidation.vue?vue&type=script&lang=js"

import "./fileTypeValidation.vue?vue&type=style&index=0&id=3feee434&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feee434"]])

export default __exports__